import React from 'react';
import './arabkir.scss'

import {useTranslate} from "react-redux-multilingual";
import {TbBuilding, TbCar, TbChevronRight} from 'react-icons/tb';


function BuildingDetailsSection(props) {
    const {setSelectedItem} = props;
    const t = useTranslate();

    const options = [
        {key: 'A', icon: TbBuilding, title: `${t('building')} ${t('A')}`, floors: 8, select: () => setSelectedItem(1, "A")},
        {key: 'B', icon: TbBuilding, title: `${t('building')} ${t('B')}`, floors: 8, select: () => setSelectedItem(1, "B")},
        {key: 'P', icon: TbCar, title: t('parking_title'), floors: 2, select: () => setSelectedItem(-1, "A")},
    ];

    return (
        <ul className="cpr-building-picker noselect">
            {options.map(({key, icon: Icon, title, floors, select}) => (
                <li key={key}>
                    <button type="button" className="cpr-building-picker__item" onClick={select}>
                        <Icon className="cpr-building-picker__icon" aria-hidden="true"/>
                        <span className="cpr-building-picker__text">
                            <span className="cpr-building-picker__title">{title}</span>
                            <span className="cpr-building-picker__meta cpr-num">{floors} {t('floors')}</span>
                        </span>
                        <TbChevronRight className="cpr-building-picker__arrow" aria-hidden="true"/>
                    </button>
                </li>
            ))}
        </ul>
    )
}

export default BuildingDetailsSection
